import styled from '@emotion/styled';
import { H3 } from '@ep/components/Typography';
import theme from '@ep/theme';
import { Gcms_Testimonial } from '@ep/types/gatsbyTypes';
import React from 'react';

export interface TestimonialProps {
  testimonial: Gcms_Testimonial;
  themeColor?: string;
}

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  scroll-snap-align: start;
  flex-shrink: 0;
  text-align: center;
  :not(:first-of-type) {
    margin-left: 2rem;
  }
`;

const Texts = styled.div`
  margin: auto auto;
  font-family: ${theme.typography.primaryFont.regular};
  ${theme.mediaQueries.desktop} {
    flex: 1;
  }
`;

const Quote = styled(H3)`
  font-size: 1.8rem;
  font-family: ${theme.typography.primaryFont.regular};
`;

const StyledMedia = styled('img')`
  margin-left: 0.1rem;
  margin-right: 2rem;
  margin-bottom: 2rem;
  border-radius: 10rem;
  width: 5rem;
  float: left;
`;

const StyledDiv = styled('div')`
  color: ${theme.colors.duskBlue};
  margin: auto auto;
  max-width: 35rem;
  ${theme.mediaQueries.mobileAndTablet} {
    max-width: 25rem;
  }
  font-size: 2rem;
  text-align: left;
  display: flex;
  justify-content: center;
`;

const Signature = styled('span')`
  font-size: 2rem;
  font-family: ${theme.typography.signatureFont};
`;

const JobTitle = styled('span')`
  font-size: 1.5rem;
`;
const ProductionName = styled.p`
  text-align: center;
  font-size: 1.5rem;
`;

const StyledP = styled('p')`
  padding: 0.8rem;
`;

const Separator = styled('span')`
  ${theme.mediaQueries.mobileAndTablet} {
    display: none;
  }
`;

function Testimonial({ testimonial }: TestimonialProps) {
  return (
    <Content>
      <Texts>
        <Quote>{testimonial.quote}</Quote>
        <StyledDiv>
          {testimonial.media && <StyledMedia src={testimonial.media.url!} />}
          <StyledP>
            <Signature>{testimonial.author}</Signature> <Separator>|</Separator>{' '}
            <JobTitle>{testimonial.jobTitle}</JobTitle>
            {testimonial.productionName && (
              <ProductionName>{testimonial.productionName}</ProductionName>
            )}
          </StyledP>
        </StyledDiv>
      </Texts>
    </Content>
  );
}

export default Testimonial;
